import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  Tab,
  Tabs,
  Spinner,
  Row,
  Col,
  Card,
  Button,
  OverlayTrigger,
  Popover,
  ListGroup,
} from "react-bootstrap";
import "../css/TripHistoryOverlay.css";

const TripHistoryOverlay = ({ onClose }) => {
  const [pending, setPending] = useState([]);
  const [upcoming, setUpcoming] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [cancelled, setCancelled] = useState([]);
  const [loading, setLoading] = useState(true);
  const contentRef = useRef();

  const handleOverlayClick = (e) => {
    if (contentRef.current && !contentRef.current.contains(e.target)) {
      onClose();
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) {
      onClose();
      return;
    }

    const user = JSON.parse(storedUser);
    const fetchTrips = async () => {
      try {
        const [pen, up, comp, cancel] = await Promise.all([
          axios.get(`http://localhost:8080/api/bookings/${user.id}/PENDING`),
          axios.get(`http://localhost:8080/api/bookings/${user.id}/UPCOMING`),
          axios.get(`http://localhost:8080/api/bookings/${user.id}/COMPLETED`),
          axios.get(`http://localhost:8080/api/bookings/${user.id}/CANCELLED`),
        ]);
        setPending(pen.data);
        setUpcoming(up.data);
        setCompleted(comp.data);
        setCancelled(cancel.data);
      } catch (err) {
        console.error("Failed to load trip history", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTrips();
  }, [onClose]);

  const renderTrips = (bookings) => {
    if (!Array.isArray(bookings) || bookings.length === 0) {
      return <p>No trips found in this category.</p>;
    }

    return (
      <Row>
        {bookings.map((booking, idx) => {
          const travellerPopover = (
            <Popover id={`popover-${idx}`}>
              <Popover.Header as="h3">Traveller Details</Popover.Header>
              <Popover.Body>
                {(booking.travellers || []).map((t, i) => (
                  <div key={i}>
                    👤 {t.name}, Age: {t.age}, 📞 {t.phone}
                  </div>
                ))}
              </Popover.Body>
            </Popover>
          );

          return (
            <Col md={4} key={idx} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Img
                  variant="top"
                  src={booking.trip.imageUrl}
                  style={{ height: "200px", objectFit: "cover" }}
                />
                <Card.Body>
                  <Card.Title>{booking.trip.title}</Card.Title>
                  <Card.Text>
                    {booking.trip.originalPrice && (
                      <del>
                        ₹{Number(booking.trip.originalPrice).toLocaleString()}
                      </del>
                    )}{" "}
                    <strong>
                      ₹{Number(booking.trip.price).toLocaleString()}
                    </strong>
                  </Card.Text>
                  <Card.Text>⏳ {booking.trip.duration}</Card.Text>
                  <Card.Text>🗓️ Travel Date: {booking.travelDate}</Card.Text>

                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={travellerPopover}
                  >
                    <Card.Text style={{ cursor: "pointer" }}>
                      👥 Travellers: {booking.noOfTravellers}
                    </Card.Text>
                  </OverlayTrigger>

                  <ListGroup className="mb-3">
                    {(booking.travellers || []).map((t, i) => (
                      <ListGroup.Item key={i} className="small">
                        👤 {t.name}, Age: {t.age}, 📞 {t.phone}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>

                  <Button
                    variant="outline-primary"
                    className="w-100"
                    onClick={onClose}
                    as="a"
                    href={`/trips/${booking.trip.path}`}
                  >
                    View Trip
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    );
  };

  return (
    <div className="trip-history-overlay" onClick={handleOverlayClick}>
      <div className="trip-history-content" ref={contentRef}>
        <Button variant="danger" className="close-btn" onClick={onClose}>
          &times;
        </Button>
        <h3 className="text-center mb-3">My Bookings</h3>

        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        ) : (
          <Tabs defaultActiveKey="upcoming" className="mb-3" fill>
            <Tab eventKey="pending" title="Pending">
              {renderTrips(pending)}
            </Tab>
            <Tab eventKey="upcoming" title="Upcoming">
              {renderTrips(upcoming)}
            </Tab>
            <Tab eventKey="completed" title="Completed">
              {renderTrips(completed)}
            </Tab>
            <Tab eventKey="cancelled" title="Cancelled">
              {renderTrips(cancelled)}
            </Tab>
          </Tabs>
        )}
      </div>
    </div>
  );
};

export default TripHistoryOverlay;
